//
//  SDKConfiguration.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class Configuration {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Static helpers and configuration
    /** Retrieve API URL for default target */
    static apiUrlForDefaultEnvironment() {
        return "https://api.supernova.io/api/v2";
    }
    /** Retrieve API URL for default AI target */
    static aiApiUrlForDefaultEnvironment() {
        return "https://ai-api.supernova.io/api";
    }
    /** Retrieve API version for the specific environment accesse */
    static apiVersionForDefaultEnvironment() {
        return "0.2";
    }
}
